export default function ArrowIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697L13.0555 12.8839C13.5436 12.3957 13.5436 11.6043 13.0555 11.1161L8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L14.1161 10.0555C15.1901 11.1294 15.1901 12.8706 14.1161 13.9445L9.53033 18.5303C9.23744 18.8232 8.76256 18.8232 8.46967 18.5303Z"
        fill="currentColor"
      />
    </svg>
  );
}
